export const isBrowserEnv = (): boolean => typeof window !== `undefined`;
